// removed by extract-text-webpack-plugin
module.exports = {"button":"WBe53rkL0lcCm56BcTjpu","buttonDefaultStyle":"_NDwXtM9OzminQiKV_HhI","selected":"_3AvimTQ7Rk1husBK42p6U4","textContainer":"_32GPZYAJGPvps6atN51HqX","betChipsContainer":"_2yPdnFmLzXxi82Txb9vt_l","betChips":"_3PNtxLxlMB-ZT5y8ZfH3p8","chipValueOuter":"GaWjf51StnWW14EsXGdJn","chipValueInner":"_1pjlnGIF5Q3-y83L_yad_V"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/desktop/modules/football/css/button.css
// module id = 1071
// module chunks = 0